var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LFeatureGroup',[(_vm.latLng)?_c('LCircle',{ref:"circle",attrs:{"lat-lng":_vm.latLng,"radius":_vm.radius}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }